import { useMemo } from 'react';
import { useMyPageRouter } from './useMyPageRouter';
const useEvent = () => {
    const viewItems = useMemo(() => [
        { label: 'OFF', value: 'off' },
        { label: 'ON', value: 'on' },
    ], []);
    const viewItemValueList = viewItems.map((v) => v.value);
    const { formatQuery, onBlurKeyword, onClickSort, onPageChange, pathname, query, } = useMyPageRouter.useQueryParams([
        { initial: 1, name: 'page', type: 'integer' },
        { initial: '', name: 'searchText', type: 'string' },
        { name: 'viewItem', selects: viewItemValueList },
        { name: 'sort', selects: ['created_at'] },
        { name: 'order', selects: ['desc', 'asc'] },
    ]);
    return {
        formatQuery,
        onBlurKeyword,
        onClickSort,
        onPageChange,
        pathname,
        query,
        viewItems,
    };
};
export const useMyPageReceiveFolder = {
    useEvent,
};
export default useMyPageReceiveFolder;
